export default __webpack_public_path__ + "static/media/striketip_white_text_url.6978d685.png";